module.exports = __webpack_public_path__ + "img/w3_circle_right_black.bc0b9bc6.png";